module.exports = __webpack_public_path__ + "img/wp-existing-habit-card10.a14c1bb6.jpg";